import styled from 'styled-components'
import { Layout } from 'antd'

export const PageLayout = styled(Layout.Content)`
  min-height: calc(100vh - 64px);
`
